import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface Props {
  value?: string;
  onChange: (input: string) => void;
  className?: string;
}

export const FilterInput: React.FC<Props> = ({ value, onChange, className }) => {
  const { t } = useTranslation();
  return (
    <Input
      placeholder={t("dataTable.filterPlaceholder")}
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      className={cn("min-w-[80px] max-w-[160px] h-[32px]", className)}
    />
  );
};
